import { graphql } from '@e-socna/data-layer';
import type { Id } from '@e-socna/data-layer';

import { ThirdPartyFormTab } from '../../enums/tab.enum';

import { ThirdPartiesSelectionFormStep } from '../Selection';

import { useInitialGridState } from './hooks/useInitialGridState.hook';

export const ThirdPartyForm_BillEmittersStep_ThirdParty_Fragment = graphql(`
  fragment ThirdPartyForm_BillEmittersStep_ThirdParty_Fragment on ThirdParty {
    billEmitterIds
  }
`);

interface Props {
  readonly id: string;
  readonly isInternal: boolean;
  readonly thirdPartyId?: Id;
}

export const ThirdPartyBillEmittersFormStep = ({
  isInternal,
  thirdPartyId,
}: Readonly<Props>) => {
  const { initialGridState } = useInitialGridState();

  return (
    <ThirdPartiesSelectionFormStep
      excludedIds={thirdPartyId ? [thirdPartyId] : undefined}
      fieldName="billEmitterIds"
      id={ThirdPartyFormTab.BillEmitters}
      initialGridState={initialGridState}
      isInternal={isInternal}
    />
  );
};
